import React from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { connectToStores } from 'fluxible-addons-react';
import { navigateAction } from 'fluxible-router';
import NavigationStore from '../../stores/NavigationStore';
import SearchBox from './SearchBox';
import SectionsList from './SectionsList';
import performSearchAction from '../../action/performSearch';

const searchIconCode = 489;
const closeIconCode = 471;

class NavigationBar extends React.Component {
  state = {
    searchActive: !!this.props.query,
    searchText: this.props.query || ''
  };

  toggleSearchActive = () => {
    this.setState(prevState => ({
      searchActive: !prevState.searchActive,
      searchText: ''
    }));
  }

  handleTextChange = (e) => {
    this.setState({ searchText: e.target.value });
  }

  handleSearch = (event, input) => {
    event.preventDefault();
    input.blur();
    const query = this.state.searchText;
    this.context.executeAction(performSearchAction, { query });
    this.context.executeAction(navigateAction, { url: `/docs/search?q=${query}` });
  }

  render() {
    const { sections, currentSection } = this.props;
    const { searchActive, searchText } = this.state;

    return (
      <div className={`navigation-bar ${searchActive ? 'is-search-active' : ''}`}>
        <div className="container">
          <Media query={'(max-width: 992px)'}>
            {isMobile => (
              <SearchBox
                text={searchText}
                icon={(searchActive && isMobile) ? closeIconCode : searchIconCode}
                handleTextChange={this.handleTextChange}
                handleSubmit={this.handleSearch}
                handleIconClick={isMobile ? this.toggleSearchActive : () => {}}
              />
            )}
          </Media>
          <SectionsList sections={sections} currentSection={currentSection} />
        </div>
      </div>
    );
  }

}

NavigationBar.contextTypes = {
  getStore: PropTypes.func,
  executeAction: PropTypes.func
};

NavigationBar.propTypes = {
  sections: PropTypes.array.isRequired,
  currentSection: PropTypes.string.isRequired,
  query: PropTypes.string
};

export default connectToStores(NavigationBar, [NavigationStore], (context) => {
  const store = context.getStore(NavigationStore);
  return {
    sections: store.getSections()
  };
});
